import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const QueriesList = lazy(() => import('../../pages/gen-ai/QueriesList'));
const KnowledgeBaseList = lazy(() => import('../../pages/gen-ai/knowledge-base/KnowledgeBaseList'));
const KnowledgeBaseDataAdd = lazy(() => import('../../pages/gen-ai/knowledge-base/AddKnowledgeBaseData'));
const WebsiteTrainingPage = lazy(() => import('../../pages/gen-ai/knowledge-base/WebsiteTrainingPage'));

function PagesRoute() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}/queries`} component={QueriesList} />
            <Route exact path={`${path}/knowledge-base`} component={KnowledgeBaseList} />
            <Route exact path={`${path}/knowledge-base/add-new`} component={KnowledgeBaseDataAdd} />
            <Route exact path={`${path}/knowledge-base/website-training/:id`} component={WebsiteTrainingPage} />
            {/* <Route path={`${path}`} component={Users} /> */}
        </Switch>
    );
}

export default PagesRoute;
